import { render, staticRenderFns } from "./fSwitch.template?vue&type=template&id=0b5e1eae&lang=pug&"
import script from "./fSwitch.client?vue&type=script&lang=ts&"
export * from "./fSwitch.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b5e1eae')) {
      api.createRecord('0b5e1eae', component.options)
    } else {
      api.reload('0b5e1eae', component.options)
    }
    module.hot.accept("./fSwitch.template?vue&type=template&id=0b5e1eae&lang=pug&", function () {
      api.rerender('0b5e1eae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/fSwitch/fSwitch.component.vue"
export default component.exports